var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-info-section'),_c('hr'),_c('publication-info-section'),_c('hr'),_c('hq-section'),_c('hr'),_c('docs-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }